<template>
  <div class="account-sec">
    <div class="list">
      <router-link
        class="item acea-row row-between-wrapper"
        v-for="(item, index) in list"
        :key="index"
        :to="item.url ? item.url : ''"
      >
        <div class="name acea-row" v-if="item.value !== ''">
          <div class="label">{{ item.name }}</div>
          <div class="value1" v-if="user[item.value].length > 20">
            {{ user[item.value] }}
          </div>
          <div class="value2" v-else-if="user[item.value].length > 14">
            {{ user[item.value] }}
          </div>
          <div class="value3" v-else>{{ user[item.value] }}</div>
        </div>
        <div class="name" v-else>
          {{ item.name }}
        </div>
        <div class="toEdit" v-if="item.url !== ''">
          <span class="iconfont icon-jiantou"></span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { getUserInfo, hasPassword } from "@api/user";

export default {
  name: "AccountSecurity",
  data: function() {
    return {
      user: {
        username: "",
        nickname: "",
        phone: ""
      },
      list: [
        {
          name: "账户名",
          url: "",
          value: "username"
        },
        {
          name: "昵称",
          url: "/user/uas/modifyNickname",
          value: "nickname"
        },
        {
          name: "手机号",
          url: "/user/uas/modifyPhone",
          value: "phone"
        }
      ],
      formItem: 0
    };
  },
  mounted: function() {
    this.User();
    this.getPasswd();
  },
  methods: {
    User: function() {
      let that = this;
      getUserInfo(2).then(res => {
        that.user = res.data;
      });
    },
    getPasswd() {
      hasPassword({ type: 1 }).then(res => {
        if (res.data.set) {
          this.formItem = 2;
          this.list.push({
            name: "修改登录密码",
            url: "/user/uas/modifyPass",
            value: ""
          });
        } else {
          this.formItem = 1;
          this.list.push({
            name: "设置登录密码",
            url: "/user/uas/setPass",
            value: ""
          });
        }
      });
    }
  }
};
</script>
